import { PartialLayerSpec } from '@/utils/layers/styleFactory/template'
import { ILayerValue } from '@lifk/types'
import { ExpressionSpecification } from 'mapbox-gl'

export default (
  _layerValues: ILayerValue[],
  mapboxColorExpression: string | ExpressionSpecification,
  mapboxOpacityExpression?: ExpressionSpecification | number
): PartialLayerSpec[] => [
  {
    id: 'lines',
    type: 'line',
    minzoom: 13,
    layout: { 'line-join': 'round' },
    paint: {
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        0,
        0,
        4,
        1.5,
        13,
        1.5,
        22,
        6
      ],
      'line-color': mapboxColorExpression,
      'line-opacity': mapboxOpacityExpression
    }
  },
  {
    id: 'lines-clickable',
    type: 'line',
    minzoom: 13,
    layout: { 'line-join': 'round' },
    paint: {
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        0,
        0,
        4,
        4,
        13,
        4,
        22,
        6
      ],
      'line-opacity': 0.01,
      'line-color': mapboxColorExpression
    }
  }
]
